import "./css/showcourse.css"
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const ShowCourse = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState(""); // Fixed typo from setMessae
    const [list, setList] = useState([]);
    const [showMessage, setShowMessage] = useState(false); // Fixed typo in variable name

    useEffect(() => {
        // We only need the token to authenticate the request
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/login");
            return;
        }

        // FIX: Changed to GET request since we are only fetching data.
        // No need to send body data anymore, the backend identifies the user via the Bearer token.
        fetch(process.env.REACT_APP_SERVER_URL + "/user/course", {
            method: "GET", 
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(result => {
                if (result.status === false && result.error === "loginError") {
                    alert("Your session has expired. Please login again to view your courses.");
                    localStorage.clear();
                    navigate("/login");
                    return;
                }

                if (result.status === false) {
                    setMessage(result.message);
                    setShowMessage(true);
                } else if (result.status === true) {
                    setList(result.response);
                    setShowMessage(false);
                }
            })
            .catch(err => {
                console.error("Error fetching courses:", err);
                setMessage("Could not load courses due to server error.");
                setShowMessage(true);
            });

    }, [navigate]);

    return (
        <div className="coursePageWrapper">
            
            {/* Empty State / No Courses Found */}
            {showMessage && (
                <div className="courseEmptyContainer">
                    <div className="courseEmptyBox">
                        <i className="fa-solid fa-book-open emptyCourseIcon"></i>
                        <h3 className="courseEmptyTitle">
                            {message}                                
                        </h3>
                        <p className="courseEmptyText">
                            Add your required exams and practice to improve yourself.
                        </p>
                        <div className="courseActionLink">
                            {/* FIX: Link changed to point to the course selection/add page, assuming "/addcourse" or similar. */}
                            <Link to="/courses" className="primaryBtn">Explore Exams</Link> 
                        </div>
                    </div>
                </div>
            )}

            {/* Courses List */}
            {!showMessage && (
                <div className="courseListMainContainer">
                    <div className="courseListHeader">
                        <h2>My Courses</h2>
                        <p>View all your enrolled exams and their validity</p>
                    </div>

                    <div className="courseListGrid">
                        {list.map((item, index) => (
                            <div className="courseCard" key={index}>
                                
                                <div className="courseCardHeader">
                                    <div className="courseExamName">{item.exam}</div>
                                    <span className="coursePaperBadge">{item.paper}</span>
                                </div>

                                <div className="courseCardBody">
                                    <div className="courseInfoRow">
                                        <span className="infoLabel">
                                            <i className="fa-regular fa-calendar"></i> Enrolled Date:
                                        </span>
                                        <span className="infoValue">
                                            {item.date ? item.date.replace(/ /g, "/") : "N/A"}
                                        </span>
                                    </div>

                                    <div className="courseInfoRow">
                                        <span className="infoLabel">
                                            <i className="fa-regular fa-clock"></i> Enrolled Time:
                                        </span>
                                        <span className="infoValue">
                                            {item.time ? item.time.replace(/ /g, ":") : "N/A"}
                                        </span>
                                    </div>

                                    <div className="courseInfoRow highlightRow">
                                        <span className="infoLabel">
                                            <i className="fa-solid fa-hourglass-half"></i> Validity:
                                        </span>
                                        <span className="infoValue validityValue">
                                            {item.validity} Month(s)
                                        </span>
                                    </div>
                                </div>
                                
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ShowCourse;